import React from 'react';
import { Award, Target, Shield, Zap } from 'lucide-react';
import { aboutInfo, companyInfo } from '../constants';

const About = () => {
  const features = [
    {
      icon: Award,
      title: "Lisanslı ve Yetkili",
      description: "0401-942 lisans numarası ile Ağrı ili genelinde tam yetki"
    },
    {
      icon: Target,
      title: "Hassas ve Doğru",
      description: "Modern teknolojik ekipmanlarla milimetrik hassasiyet"
    },
    {
      icon: Shield,
      title: "Güvenilir Hizmet",
      description: "Yasal prosedürlere tam uyum ve müşteri memnuniyeti"
    },
    {
      icon: Zap,
      title: "Hızlı Çözüm",
      description: "Deneyimli kadro ile işlerinizi en kısa sürede tamamlama"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Hakkımızda</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {aboutInfo.description}
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          {/* Left: Engineer Info */}
          <div className="bg-gradient-to-br from-sky-50 to-amber-50 rounded-2xl p-8 border border-sky-100">
            <div className="flex items-start space-x-4 mb-6">
              <div className="w-20 h-20 bg-sky-600 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white text-2xl font-bold">{companyInfo.engineer.split(' ').map(n => n[0]).join('')}</span>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-1">{aboutInfo.engineer.name}</h3>
                <p className="text-sky-600 font-semibold">{aboutInfo.engineer.title}</p>
                <p className="text-gray-600 text-sm mt-1">Lisans No: {aboutInfo.engineer.license}</p>
              </div>
            </div>
            <p className="text-gray-700 leading-relaxed">
              {aboutInfo.engineer.experience}
            </p>
            <div className="mt-6 pt-6 border-t border-sky-200">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-600 mb-1">Yetki Alanı</p>
                  <p className="font-semibold text-gray-900">Ağrı İli</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600 mb-1">Lisans Durumu</p>
                  <p className="font-semibold text-green-600">Aktif</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Features */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {features.map((feature, index) => {
              const IconComponent = feature.icon;
              return (
                <div 
                  key={index}
                  className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-sky-300 hover:shadow-lg transition-all duration-300 group"
                >
                  <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-sky-600 transition-colors">
                    <IconComponent className="w-6 h-6 text-sky-600 group-hover:text-white transition-colors" />
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">{feature.title}</h4>
                  <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="bg-slate-900 rounded-2xl p-8 sm:p-12 text-white">
          <h3 className="text-3xl font-bold mb-8 text-center">Neden Bizi Tercih Etmelisiniz?</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-sky-400 mb-2">100%</div>
              <p className="text-gray-300">Müşteri Memnuniyeti</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-amber-400 mb-2">Hızlı</div>
              <p className="text-gray-300">İşlem Süreci</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-400 mb-2">Güvenilir</div>
              <p className="text-gray-300">Profesyonel Hizmet</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;